/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Keyword_Optimizer_Cliche_Col_SuggestionInputs */

const en_keyword_optimizer_cliche_col_suggestion = /** @type {(inputs: Keyword_Optimizer_Cliche_Col_SuggestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suggestion`)
};

const de_keyword_optimizer_cliche_col_suggestion = /** @type {(inputs: Keyword_Optimizer_Cliche_Col_SuggestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suggestion`)
};

const fr_keyword_optimizer_cliche_col_suggestion = /** @type {(inputs: Keyword_Optimizer_Cliche_Col_SuggestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suggestion`)
};

const es_keyword_optimizer_cliche_col_suggestion = /** @type {(inputs: Keyword_Optimizer_Cliche_Col_SuggestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suggestion`)
};

const it_keyword_optimizer_cliche_col_suggestion = /** @type {(inputs: Keyword_Optimizer_Cliche_Col_SuggestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suggestion`)
};

const nl_keyword_optimizer_cliche_col_suggestion = /** @type {(inputs: Keyword_Optimizer_Cliche_Col_SuggestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suggestion`)
};

const pl_keyword_optimizer_cliche_col_suggestion = /** @type {(inputs: Keyword_Optimizer_Cliche_Col_SuggestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suggestion`)
};

const fi_keyword_optimizer_cliche_col_suggestion = /** @type {(inputs: Keyword_Optimizer_Cliche_Col_SuggestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suggestion`)
};

const da_keyword_optimizer_cliche_col_suggestion = /** @type {(inputs: Keyword_Optimizer_Cliche_Col_SuggestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suggestion`)
};

const sv_keyword_optimizer_cliche_col_suggestion = /** @type {(inputs: Keyword_Optimizer_Cliche_Col_SuggestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suggestion`)
};

/**
* | output |
* | --- |
* | "Suggestion" |
*
* @param {Keyword_Optimizer_Cliche_Col_SuggestionInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const keyword_optimizer_cliche_col_suggestion = /** @type {((inputs?: Keyword_Optimizer_Cliche_Col_SuggestionInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Keyword_Optimizer_Cliche_Col_SuggestionInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_keyword_optimizer_cliche_col_suggestion(inputs)
	if (locale === "fr") return fr_keyword_optimizer_cliche_col_suggestion(inputs)
	if (locale === "es") return es_keyword_optimizer_cliche_col_suggestion(inputs)
	if (locale === "it") return it_keyword_optimizer_cliche_col_suggestion(inputs)
	if (locale === "nl") return nl_keyword_optimizer_cliche_col_suggestion(inputs)
	if (locale === "pl") return pl_keyword_optimizer_cliche_col_suggestion(inputs)
	if (locale === "fi") return fi_keyword_optimizer_cliche_col_suggestion(inputs)
	if (locale === "da") return da_keyword_optimizer_cliche_col_suggestion(inputs)
	if (locale === "sv") return sv_keyword_optimizer_cliche_col_suggestion(inputs)
	return en_keyword_optimizer_cliche_col_suggestion(inputs)
});